module.exports = __webpack_public_path__ + "img/team.f6fd857a.svg";